var mainMenu = new function() {
  this.init = function () {
    $('#navbar-collapse').on('show.bs.modal', function() {
      $('.navbar-toggle').addClass('modal-active');
    });

    $('#navbar-collapse').on('hide.bs.modal', function() {
      $('.navbar-toggle').removeClass('modal-active');
    });
  }
}
